import axios from 'axios';
import qs from 'qs';

const processCheckout = ({ body }) => axios.post('checkout/processCheckout', qs.stringify(body));
const blockSeat = ({ body }) => axios.post('checkout/blockSeat', qs.stringify(body));
const getReceipt = ({transactionId}) => axios.get(`checkout/receipt/${transactionId}`);



export default {
    processCheckout,
    blockSeat,
    getReceipt
};
